// extracted by mini-css-extract-plugin
export default {"container":"uv6KNq1vIUK8XGNMebP9","confirmButton":"zBHlRFFPwStD4HZMuZBz","state":"bZwWAeEHrU9GmfBmHUA1","stateText":"Y0TC2l27ry0sCQdhk3Yo"};